import styled, { css } from 'styled-components';
import Logo from 'images/logo-v3.png';
import { COLORS } from 'constants/colors';
import { useDimensions } from 'hooks/useDimensions';
import { useHistory } from 'react-router';
import { isTouch } from 'utils/isTouch';
import OpenseaLogo from 'images/opensea.png';
import WebsiteLogo from 'images/website.png';
import InstagramLogo from 'images/instagram.png';
import TwitterLogo from 'images/twitter.png';
import RedditLogo from 'images/reddit.png';
import DiscordLogo from 'images/discord.png';
import { ImagePlaceholder } from './ImagePlaceholder';
import { DISCORD_LINK, INSTAGRAM_LINK, OPENSEA_LINK, REDDIT_LINK, TWITTER_LINK } from 'CardCarousel/constants';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: ${COLORS.black};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  max-height: 600px;
`;

const Item = styled.a`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 300px;
  height: 35px;
  border: 3px solid ${COLORS.white};
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: capitalize;
  font-weight: 600;
  text-decoration: none;
  color: ${COLORS.white};

  transition: 0.5s;

  ${!isTouch &&
  css`
    &:hover {
      background-color: ${COLORS.white};
      color: ${COLORS.black};
      transform: scale(1.08);
    }
  `}
`;

export const Links = () => {
  const { height } = useDimensions();
  const { push } = useHistory();

  const isLittleHeight = height < 680;

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
    >
      <Wrapper style={{ padding: '50px' }}>
        <Grid>
          <ImagePlaceholder
            width={isLittleHeight ? 150 : 200}
            height={isLittleHeight ? 150 : 200}
            src={Logo}
            style={{ margin: 'auto' }}
            firstColor={'#000'}
            secondColor={'#292929'}
          />
          <Item isLittleHeight={isLittleHeight} href={OPENSEA_LINK} target="_blank">
            <img alt="" src={OpenseaLogo} style={{ position: 'absolute', height: 20, left: 15 }} />
            <div>Opensea</div>
          </Item>
          <Item isLittleHeight={isLittleHeight} onClick={() => push('/')}>
            <img
              alt=""
              src={WebsiteLogo}
              style={{ position: 'absolute', height: 20, left: 15, backgroundColor: COLORS.black, borderRadius: '50%' }}
            />
            <div>Website</div>
          </Item>
          <Item isLittleHeight={isLittleHeight} href={INSTAGRAM_LINK} target={isTouch ? null : '_blank'}>
            <img alt="" src={InstagramLogo} style={{ position: 'absolute', height: 20, left: 15 }} />
            <div>Instagram</div>
          </Item>
          <Item isLittleHeight={isLittleHeight} href={TWITTER_LINK} target={isTouch ? null : '_blank'}>
            <img alt="" src={TwitterLogo} style={{ position: 'absolute', height: 20, left: 15 }} />
            <div>Twitter</div>
          </Item>
          <Item isLittleHeight={isLittleHeight} href={DISCORD_LINK} target={isTouch ? null : '_blank'}>
            <img alt="" src={DiscordLogo} style={{ position: 'absolute', height: 20, left: 15 }} />
            <div>Discord</div>
          </Item>
          <Item isLittleHeight={isLittleHeight} href={REDDIT_LINK} target={isTouch ? null : '_blank'}>
            <img alt="" src={RedditLogo} style={{ position: 'absolute', height: 20, left: 15 }} />
            <div>Reddit</div>
          </Item>
        </Grid>
      </Wrapper>
    </div>
  );
};
